import React from 'react';

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-slate-50 dark:bg-slate-950 py-20 px-6">
    <div className="container mx-auto max-w-4xl bg-white dark:bg-slate-900 p-8 md:p-12 rounded-3xl shadow-sm border border-slate-100 dark:border-slate-800">
      <h1 className="text-4xl font-black mb-8 text-slate-800 dark:text-white">Política de Privacidade</h1>
      <div className="prose prose-slate dark:prose-invert max-w-none space-y-6 text-slate-600 dark:text-slate-400">
        <p>A sua privacidade é importante para nós. É política do Emprega Mais Rondônia respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar.</p>
        <h2 className="text-2xl font-bold text-slate-800 dark:text-white">Cookies e Google AdSense</h2>
        <p>O Google, como fornecedor de terceiros, utiliza cookies para exibir anúncios no nosso site. O uso do cookie DART permite ao Google exibir anúncios com base nas visitas feitas a este e outros sites na Internet.</p>
        <h2 className="text-2xl font-bold text-slate-800 dark:text-white">LGPD</h2>
        <p>Estamos em conformidade com a Lei Geral de Proteção de Dados (LGPD). Você tem o direito de solicitar a exclusão de seus dados a qualquer momento através da nossa página de contato.</p>
      </div>
    </div>
  </div>
);

export default PrivacyPolicy;